import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import EmptyImage from "../../../assets/img/ic_content.svg";
import ModalContainer from "../../ModalContainer.tsx";
import Form from "../Form.tsx";
import { useNavigate } from "react-router-dom";
import EditTime from "./EditTime.tsx";
import EditFullDayHours from "./EditFullDayHours.tsx";
import { Tooltip } from "@mui/material";
import EditBranchMessage from "./componentes/EditBranchMessage.tsx";
import { useWebSocket } from "../../../hooks/useWebSocket.tsx";
import {
  setDefaultSort,
  setPage,
  setSortBy,
} from "../../../store/slices/sucursalesSlice.ts";
import { fixedHeadStyle, fixedStyle } from "../../../utils/constanst.js";
import ModalTacticaJuego from "../../tactica-juego/ModalTacticaJuego.tsx";
interface DataObject {
  id?: number;
  name?: string;
  isActive?: boolean;
  candidates?: Array<any>;
}

const TableSucursales = ({ user, refetch }) => {
  const allowed = user.rol !== "Lider de sucursal";
  const block = user.rol === 'Líder de líderes';
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [record, setRecord] = useState<DataObject>();
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showEditTimeModal, setShowEditTimeModal] = useState<boolean>(false);
  const [showEditFullDayHoursModal, setShowEditFullDayHoursModal] = useState<boolean>(false);
  const [branchId, setBranchId] = useState<number>(-99);
  const [modalText, setModalText] = useState<boolean>(false);
  const [modalTactica, setModalTactica] = useState<boolean>(false);
  const [showTacticaBadge, setShowTacticaBadge] = useState<boolean>(() => {
    const hasOpenedTactica = localStorage.getItem("tactica-juego-opened");
    return !hasOpenedTactica;
  });

  const { sucursalesList, sortBy, defaultSort, query } = useSelector(
    (state: RootState) => state.sucursales
  );
  const hasPartnerName = query.includes("partnerName");

  const setSort = (sort: string) => {
    const sortOrder =
      sortBy !== sort ? "asc" : defaultSort === "asc" ? "desc" : "asc";
    dispatch(setSortBy(sort));
    dispatch(setPage(0));
    dispatch(setDefaultSort(sortOrder));
  };

  const getIconSort = () => {
    return (
      <i
        className={`fa-solid fa-sort-${defaultSort === "asc" ? "up" : "down"}`}
      />
    );
  };
  const getButtonStyle = (color: string) => ({
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: "none",
    backgroundColor: color,
    color: "white",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: `0 2px 4px ${color}40`,
    padding: 0,
    margin: "0 0.15rem",
  });

  return (
    <div
      className="mb-3"
      style={{ borderRadius: "0.75rem", overflow: "hidden" }}
    >
      <div
        className="table-responsive"
        style={{ overflowY: "auto", maxHeight: "60vh" }}
      >
        <table className="table table-hover table-panel text-nowrap align-middle mb-0">
          <thead>
            <tr style={{ ...fixedHeadStyle, cursor: "pointer" } as React.CSSProperties}>
            <th
              style={{ ...fixedStyle, width: "10%" } as React.CSSProperties}
              onClick={() => setSort("id")}
            >
              ID {sortBy === "id" && getIconSort()}
            </th>
            <th style={{ width: "23%" }} onClick={() => setSort("name")}>
              Sucursales{sortBy === "name" && getIconSort()}
            </th>
            <th
              style={{ width: "22%" }}
              onClick={() => setSort("templateBranch")}
            >
              Plantilla{sortBy === "templateBranch" && getIconSort()}
            </th>
            <th style={{ width: "22%" }} onClick={() => setSort("isActive")}>
              Activa{sortBy === "isActive" && getIconSort()}
            </th>
            <th className="text-center" style={{ width: "20%" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {sucursalesList && sucursalesList.length > 0 ? (
            sucursalesList
              .filter((item) => {
                if (allowed) {
                  return item;
                } else {
                  return item.name === user.branch;
                }
              })
              .map((item, index) => (
                <tr key={index}>
                  <td style={{ ...fixedStyle } as React.CSSProperties}>
                    {item.id}
                  </td>
                  <td style={{ width: "23%" }}>
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ width: "100%" }}
                    >
                      <span
                        style={{
                          marginRight: "20px",
                          flex: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontWeight: "bold",
                        }}
                      >
                        {item.name}
                      </span>
                      {item.candidates &&
                      item.candidates.length > 0 &&
                      hasPartnerName ? (
                        <div className="d-flex align-items-center">
                          {item.candidates
                            .slice(0, 2)
                            .map((candidate, index) => {
                              const colors = [
                                "bg-warning",
                                "bg-success",
                                "bg-dark",
                              ];

                              return (
                                <Tooltip
                                  title={`${candidate.person.firstName} ${candidate.person.lastName}`}
                                  arrow
                                  key={candidate.id}
                                >
                                  <div
                                    className="avatar"
                                    style={{ marginRight: "5px" }}
                                  >
                                    <div
                                      className={`avatar ${
                                        colors[index % colors.length]
                                      } text-white d-flex align-items-center justify-content-center`}
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                      }}
                                    >
                                      {candidate.person.firstName.charAt(0)}
                                      {candidate.person.lastName.charAt(0)}
                                    </div>
                                  </div>
                                </Tooltip>
                              );
                            })}
                          {item.candidates.length > 2 && (
                            <Tooltip
                              title={item.candidates
                                .slice(2)
                                .map(
                                  (candidate) =>
                                    `(${candidate.person.firstName} ${candidate.person.lastName})`
                                )
                                .join(", ")}
                              arrow
                            >
                              <div
                                className="avatar bg-secondary text-white d-flex align-items-center justify-content-center"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "50%",
                                }}
                              >
                                +{item.candidates.length - 2}
                              </div>
                            </Tooltip>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </td>
                  <td style={{ width: "22%" }}>
                    {item?.templateBranch?.name ?? "Sin plantilla"}
                  </td>
                  <td style={{ width: "22%" }}>
                    {item.isActive ? "Activa" : "Desactiva"}
                  </td>
                  <td className="text-center" style={{ width: "20%" }}>
                    <div style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", gap: "0.15rem", flexWrap: "nowrap" }}>
                    {allowed && !block && (
                        <Tooltip title={`Editar`} arrow>
                        <button
                          style={getButtonStyle("#50B7C0")}
                            onClick={() => {
                              setRecord(item);
                              navigate(`editar/${item.id}`);
                            }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(80, 183, 192, 0.4)";
                            e.currentTarget.style.backgroundColor = "#3A9BA3";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(80, 183, 192, 0.25)";
                            e.currentTarget.style.backgroundColor = "#50B7C0";
                          }}
                        >
                            <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                        </Tooltip>
                    )}
                    {/* Colaboradores */}
                    <Tooltip title={`Colaboradores`} arrow>
                      <button
                        style={getButtonStyle("#50B7C0")}
                        onClick={() => {
                          navigate(`colaboradores/${item.id}`);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(80, 183, 192, 0.4)";
                          e.currentTarget.style.backgroundColor = "#3A9BA3";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(80, 183, 192, 0.25)";
                          e.currentTarget.style.backgroundColor = "#50B7C0";
                        }}
                      >
                        <i className="fa-solid fa-users"></i>
                      </button>
                    </Tooltip>

                    {/* Plantilla de puestos contra colaboradores */}
                    <Tooltip
                      title={`Plantilla de puestos contra colaboradores`}
                      arrow
                    >
                      <button
                        style={getButtonStyle("#28a745")}
                        onClick={() => {
                          setRecord(item);
                          navigate(`reporte-plantilla/${item.id}`);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(40, 167, 69, 0.4)";
                          e.currentTarget.style.backgroundColor = "#218838";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(40, 167, 69, 0.25)";
                          e.currentTarget.style.backgroundColor = "#28a745";
                        }}
                      >
                        <i className="fa-solid fa-arrows-down-to-people"></i>
                      </button>
                    </Tooltip>

                    {/* Tactica de juego */}
                    <Tooltip title={`Tactica de juego`} arrow>
                      <button
                        style={{
                          ...getButtonStyle("#6f42c1"),
                          position: "relative",
                        }}
                        onClick={() => {
                          setBranchId(item.id);
                          setModalTactica(true);
                          if (showTacticaBadge) {
                            localStorage.setItem("tactica-juego-opened", "true");
                            setShowTacticaBadge(false);
                          }
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(111, 66, 193, 0.4)";
                          e.currentTarget.style.backgroundColor = "#5a32a3";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(111, 66, 193, 0.25)";
                          e.currentTarget.style.backgroundColor = "#6f42c1";
                        }}
                      >
                        <i className="fa-solid fa-chess-king"></i>
                        {showTacticaBadge && (
                        <span
                          style={{
                              position: "absolute",
                              top: "-6px",
                              right: "-8px",
                              backgroundColor: "#dc3545",
                              color: "white",
                              borderRadius: "12px",
                              padding: "2px 6px",
                              fontSize: "9px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              minWidth: "36px",
                            }}
                          >
                            Nuevo
                        </span>
                        )}
                      </button>
                    </Tooltip>

                    {/* Reporte de chequeo */}
                    {/* <Tooltip title={`Reporte de chequeo`} arrow>
                      <a
                        className="btn btn-amarillo m-2"
                        onClick={() => {
                          navigate(`chequeo/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-list"></i>
                      </a>
                    </Tooltip> */}

                    {/* Cobertura puestos */}
                    <Tooltip title={`Cobertura puestos`} arrow>
                      <button
                        style={getButtonStyle("#28a745")}
                        onClick={() => {
                          setRecord(item);
                          navigate(`cobertura-puestos/${item.id}`);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(40, 167, 69, 0.4)";
                          e.currentTarget.style.backgroundColor = "#218838";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(40, 167, 69, 0.25)";
                          e.currentTarget.style.backgroundColor = "#28a745";
                        }}
                      >
                        <i className="fa-solid fa-list-check"></i>
                      </button>
                    </Tooltip>

                    {/* Horario Pendiente */}
                    {/* <Tooltip title={`Horario`} arrow>
                      <a
                        className="btn btn-amarillo m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`horario/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-calendar-days"></i>
                      </a>
                    </Tooltip> */}

                    {/* Resumen horario (Horario en forma de excel) */}
                    {/* <Tooltip title={`Resumen horario`} arrow>
                      <a
                        className="btn btn-azul m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`resumen-horario/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-list-check"></i>
                      </a>
                    </Tooltip> */}

                    {/* Inasistencias */}
                    {/* <Tooltip title={`Inasistencias`} arrow>
                      <a
                        className="btn btn-rojo m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`inasistencias/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-clipboard-list"></i>
                      </a>
                    </Tooltip> */}

                    {/* Incidencias */}
                    {/* <Tooltip title={`Incidencias`} arrow>
                      <a
                        className="btn btn-azul m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`incidencias/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </a>
                    </Tooltip> */}

                    {/* Resumen de asistencias por turno (Pendiente tiempo real) */}
                    {/* <Tooltip title={`Resumen de asistencias por turno`} arrow>
                      <a
                        className="btn btn-verde m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`resumen-horario-asistencia/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-clipboard-list"></i>
                      </a>
                    </Tooltip> */}

                    {/* Asistencia(horario en una vista) (Pendiente tiempo real) */}
                    {/* <Tooltip title={`Asistencias`} arrow>
                      <a
                        className="btn btn-verde m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`asistencias/${item.id}/horario`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-clipboard-user"></i>
                      </a>
                    </Tooltip> */}

                    {/* Traspasos */}
                    <Tooltip title={`Traspasos`} arrow>
                      <button
                        style={getButtonStyle("#ffc107")}
                        onClick={() => {
                          setRecord(item);
                          navigate(`traspasos/${item.id}`);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(255, 193, 7, 0.4)";
                          e.currentTarget.style.backgroundColor = "#e0a800";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(255, 193, 7, 0.25)";
                          e.currentTarget.style.backgroundColor = "#ffc107";
                        }}
                      >
                        <i className="fa-solid fa-shuffle"></i>
                      </button>
                    </Tooltip>

                    {/* Reporte turnos
                    <Tooltip title={`Reporte de turnos`} arrow>
                      <a
                        className="btn btn-azul m-2"
                        onClick={() => {
                          setRecord(item);
                          navigate(`reporte/${item.id}`);
                        }}
                      >
                        <span className="d-none d-sm-inline"></span>
                        <i className="fa-solid fa-table-list"></i>
                      </a>
                    </Tooltip> */}

                    {/* Banner */}
                    <Tooltip title={`Editar banner`} arrow>
                      <button
                        style={getButtonStyle("#17a2b8")}
                        onClick={() => {
                          setModalText(true);
                          setBranchId(item.id);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(23, 162, 184, 0.4)";
                          e.currentTarget.style.backgroundColor = "#138496";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(23, 162, 184, 0.25)";
                          e.currentTarget.style.backgroundColor = "#17a2b8";
                        }}
                      >
                        <i className="fa-solid fa-message"></i>
                      </button>
                    </Tooltip>

                    {/* Configuracion turnos */}
                    <Tooltip title={`Editar horarios`} arrow>
                      <button
                        style={getButtonStyle("#6c757d")}
                        onClick={() => {
                          setShowEditTimeModal(true);
                          setBranchId(item.id);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(108, 117, 125, 0.4)";
                          e.currentTarget.style.backgroundColor = "#5a6268";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(108, 117, 125, 0.25)";
                          e.currentTarget.style.backgroundColor = "#6c757d";
                        }}
                      >
                        <i className="fa-solid fa-clock"></i>
                      </button>
                    </Tooltip>

                    {/* Cumpleaños */}
                    <Tooltip title={`Cumpleaños`} arrow>
                      <button
                        style={getButtonStyle("#e83e8c")}
                        onClick={() => {
                          setRecord(item);
                          navigate(`birthdates/${item.id}`);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(232, 62, 140, 0.4)";
                          e.currentTarget.style.backgroundColor = "#d91a72";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(232, 62, 140, 0.25)";
                          e.currentTarget.style.backgroundColor = "#e83e8c";
                        }}
                      >
                        <i className="fa-solid fa-cake-candles"></i>
                      </button>
                    </Tooltip>

                    {/* Horas de jornada completa */}
                    <Tooltip title={`Configurar horas de jornada completa`} arrow>
                      <button
                        style={getButtonStyle("#fd7e14")}
                        onClick={() => {
                          setShowEditFullDayHoursModal(true);
                          setBranchId(item.id);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(253, 126, 20, 0.4)";
                          e.currentTarget.style.backgroundColor = "#dc6502";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(253, 126, 20, 0.25)";
                          e.currentTarget.style.backgroundColor = "#fd7e14";
                        }}
                      >
                        <i className="fa-solid fa-hourglass-half"></i>
                      </button>
                    </Tooltip>
                    </div>
                  </td>
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan={5}>
                <div className="py-4">
                  <div className="d-flex">
                    <img src={EmptyImage} alt="" className="mx-auto w-250px" />
                  </div>
                  <h5 className="text-secondary text-center fs-20px">
                    No existen sucursales aún
                  </h5>
                  <p className="text-center text-secondary fw-400 fs-15px mb-0">
                    Prueba añadiendo una en el botón de &quot;Agregar sucursal&quot;
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
        </table>
      </div>

      {showEditModal && (
        <ModalContainer
          open={showEditModal}
          title="Editar sucursal"
          closeFn={() => setShowEditModal(false)}
          children={
            <Form
              closeFn={() => {
                setShowEditModal(false);
                refetch();
              }}
              tapSelected="branches"
              dataToEdit={record || {}}
            />
          }
        />
      )}

      {showDeleteModal && (
        <ModalContainer
          open={showDeleteModal}
          title={record?.isActive ? "Desactivar sucursal" : "Activar sucursal"}
          closeFn={() => setShowDeleteModal(false)}
          children={
            <Form
              closeFn={() => {
                setShowDeleteModal(false);
                refetch();
              }}
              tapSelected="branches"
              dataToDelete={record || null}
              dataToEdit={{}}
            />
          }
        />
      )}

      <ModalContainer
        open={showEditTimeModal}
        title={"Editar horarios sucursal"}
        closeFn={() => setShowEditTimeModal(false)}
        children={
          <EditTime
            branchId={branchId}
            closeFn={() => setShowEditTimeModal(false)}
            refreshFn={refetch}
            setLoading={() => {}}
          />
        }
      />

      <ModalContainer
        open={showEditFullDayHoursModal}
        title={"Configurar horas de jornada completa"}
        closeFn={() => setShowEditFullDayHoursModal(false)}
        children={
          <EditFullDayHours
            branchId={branchId}
            closeFn={() => setShowEditFullDayHoursModal(false)}
            refreshFn={refetch}
            setLoading={() => {}}
          />
        }
      />

      <ModalContainer
        open={modalText}
        title={"Editar mensaje de la sucursal"}
        closeFn={() => setModalText(false)}
        children={
          <EditBranchMessage
            branchId={branchId}
            closeFn={() => setModalText(false)}
          />
        }
        size="lg"
      />

      <ModalContainer
        open={modalTactica}
        title={"Tactica de juego"}
        closeFn={() => setModalTactica(false)}
        children={
          <ModalTacticaJuego
            closeFn={() => setModalTactica(false)}
            branchId={branchId}
          />
        }
        size="lg"
      />
    </div>
  );
};

export default TableSucursales;
